"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductName = void 0;
var ProductName;
(function (ProductName) {
    ProductName["MM1"] = "MM1";
    ProductName["MM2"] = "MM2";
})(ProductName || (exports.ProductName = ProductName = {}));
//# sourceMappingURL=product-name.js.map